import { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Swal from 'sweetalert2';

class Documents extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            loadingList: false,
            postLoading: false,
            document_info: [],
            documents: [],
            letters: [],
            salaries: [],
            employee_document_uid: ''
        };
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
        })
    }

    Remark = (document_remark) => {
        Swal.fire({
            title: "warning",
            text: document_remark || "No Remark !!",
            icon: 'info',
        });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
    };

    handleFileUpload = (event, row) => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('employee_document', file);
        formData.append('employee_document_id', row.employee_document_id);
        formData.append('employee_document_uid', row.employee_document_uid);

        const { apiURL, apiHeaderFile } = this.context;
        const headers = apiHeaderFile;

        axios.post(`${apiURL}Home/UploadEmployeeDocument`, formData, { headers })
            .then((response) => {
                Swal.fire({
                    title: `<strong>${response.data.message}</strong>`,
                    icon: 'success',
                })
                this.GetList();
            })
            .catch((error) => {
                console.error('Error uploading file:', error);
            });
    };

    GetList = () => {
        const { apiURL, apiHeaderJSON, employee_id } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetProfile?employee_id=${employee_id}`, { headers }).then((response) => {
            var data = response.data.data.documents;


            if (response.data.success === true) {
                this.setState({
                    rows: data,
                    document_info: data.employee,
                    documents: data.documents,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    };

    render() {
        const { rows } = this.state;
        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`Documents`} primary={`My details`} />
                                <div className="card">
                                    <div className="card-body">
                                        <div class="card-header bg-light bg-gradient">
                                            <h6 className="card-title mb-0 text-center" >DOCUMENTS</h6>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-lg-12">
                                                <div className="table-responsive">
                                                    <table className="table table-borderless text-center table-hover align-middle mb-0">
                                                        <thead className="bg-primary text-light bg-gradient ">
                                                            <tr>
                                                                <th scope="col" className="text-start">
                                                                    File Name
                                                                </th>

                                                                <th scope="col">
                                                                    Remark
                                                                </th>
                                                                <th scope="col">
                                                                    Status
                                                                </th>
                                                                <th scope="col">
                                                                    Upload
                                                                </th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rows.map((row) => (
                                                                <tr key={row.employee_document_id}>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="avatar-sm">
                                                                                <div className="avatar-title bg-danger-subtle text-danger rounded fs-20">
                                                                                    <i className="ri-image-2-fill" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="ms-3 flex-grow-1">
                                                                                <h6 className="fs-15 mb-0 text-start">
                                                                                    <a href="#">{row.employee_document_type_title}</a>
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td><i
                                                                        className={`bx bx-info-circle`}
                                                                        style={{
                                                                            fontSize: "20px",
                                                                            cursor: "pointer",
                                                                            color: row.document_status_label === "Verified" ? "gray" : "inherit",
                                                                        }}
                                                                        onClick={() => {
                                                                            if (row.document_status_label !== "Verified") {
                                                                                this.Remark(row.document_remark);
                                                                            }
                                                                        }}
                                                                    />
                                                                    </td>

                                                                    <td>
                                                                        <span className={`badge bg-${row.document_status_color}`} >{row.document_status_label}</span>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="file"
                                                                            id={`fileInput-${row.employee_document_id}`}
                                                                            style={{ display: 'none' }}
                                                                            onChange={(e) => this.handleFileUpload(e, row)}
                                                                            accept="image/png, image/jpg, image/jpeg"
                                                                        />
                                                                        {row.document_status_label === 'Uploaded' ? (
                                                                            <>
                                                                                <label
                                                                                    htmlFor={`fileInput-${row.employee_document_id}`}
                                                                                    className="btn btn-secondary btn-label waves-effect waves-light"
                                                                                >
                                                                                    <i className=" ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                                                                    Change
                                                                                </label>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <label
                                                                                    htmlFor={`fileInput-${row.employee_document_id}`}
                                                                                    className="btn btn-primary btn-label waves-effect waves-light"
                                                                                >
                                                                                    <i className=" ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                                                                    Upload
                                                                                </label>
                                                                            </>
                                                                        )}

                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default Documents;